import { useMemo } from 'react';

import { AppParts, useCanView, useNavigate } from '@work4all/data';

import { useTimeTracker } from './use-time-tracker';
import { WorkHoursButton } from './WorkHoursButton';

export class TimeTrackerProps {
  className?: string;
}

export function TimeTracker(props: TimeTrackerProps) {
  const navigate = useNavigate();
  const canViewWorkTimeTracking = useCanView(AppParts.WORKTIMETRACKING);

  const isWorkTimeEnabled = useMemo(() => {
    return canViewWorkTimeTracking;
  }, [canViewWorkTimeTracking]);

  const tracker = useTimeTracker({
    disabled: !isWorkTimeEnabled,
    amplitudeEntryPoint: 'NavigationBar',
  });

  if (!tracker.result) {
    return null;
  }

  return isWorkTimeEnabled ? (
    <WorkHoursButton
      tracker={tracker}
      onClick={() => navigate('/more/timetracking')}
      className={props.className}
    />
  ) : null;
}
